export const STATUSES = ['created', 'booked', 'expired']
